module.exports = __webpack_public_path__ + "img/util-tab-2-title.a8e07cb3.svg";